import type { FC } from "react";
import { css } from "@stubhub/broadway-foundation/css";
import type { Champion } from "src/http/types";
import { ChampionSection } from "src/website-apps/responsive/stubhub-performer/components/performer-info-card/reigning-champion/ChampionSection";

const reigningChampionWrapper = css({
  display: "flex",
  flexDirection: "column",
  rowGap: "primitives.300",
});

interface Props {
  /** An array of arrays, each containing champion objects. */
  reigningChampionData: Champion[][] | null;
}

/**
 * ReigningChampion component displays a list of ChampionSection components.
 */
export const ReigningChampion: FC<Props> = ({ reigningChampionData }) => (
  <div className={reigningChampionWrapper}>
    {reigningChampionData?.map((champions) => (
      <ChampionSection
        key={champions.map((c) => c.name).join("-")}
        champions={champions}
        sectionTitle={champions[0]?.sectionTitle}
      />
    ))}
  </div>
);
